export const top = () => {
  if (document.getElementById("top")) {
    document.querySelector(".reservation").classList.add("topReservation");

    if (window.innerWidth < 768) {
      document.querySelector(".header__titleText").classList.add("show");
      document.querySelector(".header__titleText").classList.add("top");

      if (window.scrollY > 5) {
        document.querySelector(".header__titleText").classList.remove("show");
        document.querySelector(".header__titleText").classList.remove("top");
      }

      window.addEventListener("scroll", function () {
        const headerTitleText = document.querySelector(".header__titleText");
        if (window.scrollY > 5) {
          headerTitleText.classList.remove("show");
          headerTitleText.classList.remove("top");
        } else if (window.scrollY > 0) {
          headerTitleText.classList.remove("show");
          headerTitleText.classList.add("top");
        } else {
          headerTitleText.classList.add("show");
          headerTitleText.classList.add("top");
        }
      });
    }

    const hospitalilySlide = new Swiper("#topHospitalitySlide", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 1800,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".topHospitality__button--next",
        prevEl: ".topHospitality__button--prev",
      },
    });

    const slides = document.getElementById("topSekkiSlide").querySelectorAll(".swiper-slide");
    let slideHeights = [];
    slides.forEach((slide) => slideHeights.push(slide.clientHeight));

    const sekkiSlide = new Swiper("#topSekkiSlide", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 3000,
      effect: "fade",
      fadeEffect: { crossFade: true },
      navigation: {
        nextEl: ".topSekki__slide-button--next",
        prevEl: ".topSekki__slide-button--prev",
      },
      pagination: {
        el: ".topSekki__slide-pagination",
        clickable: true,
      },
    });

    sekkiSlide.on("slideChange", () => {
      setTimeout(() => {
        let first = true;
        slides.forEach((slide) => {
          if (slide.classList.contains("swiper-slide-active")) {
            let index = Array.from(slides).indexOf(slide);
            document.getElementById("topSekkiSlide").style.height = `${slideHeights[index]}px`;
            first = false;
          }

          if (first) {
            document.getElementById("topSekkiSlide").style.height = `${slideHeights[0]}px`;
          }
        });
      }, 500);
    });

    document.getElementById("topSekkiSlide").style.height = `${slideHeights[0]}px`;

    document.querySelectorAll(".fvCardItem").forEach((item) => {
      // ホバー時の処理
      item.addEventListener("mouseover", () => {
        if (window.matchMedia("(min-width: 768px)").matches) {
          document.querySelector(".fvImg.current").classList.remove("current");
          document.getElementById(item.dataset.targetId).classList.add("current");
        }
      });
    });

    // fvのフェード切り替え
    const images = document.querySelectorAll(".fvImg");
    let currentIndex = 0;
    setInterval(() => {
      images[currentIndex].classList.remove("current");
      currentIndex = (currentIndex + 1) % images.length;
      images[currentIndex].classList.add("current");
    }, 5000);
  }
};
